/**
 * The stages of a transcription production
 */
export var JobStatus;
(function (JobStatus) {
    /**
     * A job that's been created but not yet assigned to a transcriber
     */
    JobStatus["Pending"] = "pending";
    /**
     * A job that's been assigned to a transcriber and is currently being produced
     */
    JobStatus["Assigned"] = "assigned";
    /**
     * A job where the transcriber has submitted a transcript
     * that is currently being reviewed by a user that can process transcript orders
     */
    JobStatus["InReview"] = "in review";
    /**
     * A job that has been canceled at any point in the transcript production
     */
    JobStatus["Canceled"] = "canceled";
    /**
     * A job that has produced a transcript and accepted by a clerk
     */
    JobStatus["Completed"] = "completed";
})(JobStatus || (JobStatus = {}));
/**
 * Which jobs can't be canceled
 */
export const FINISHED_JOB_STATUSES = [JobStatus.Canceled, JobStatus.Completed];
/**
 * Statuses that indicate a transcript needs to be submitted.
 */
export const UNSUBMITTED_JOB_STATUSES = [JobStatus.Pending, JobStatus.Assigned];
/**
 * Statuses that indicate a transcript is submitted.
 */
export const SUBMITTED_JOB_STATUSES = [JobStatus.InReview];
